// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AssetHeading_wrapper__Uu_Ra","contentWrapper":"AssetHeading_contentWrapper__zlXd_"};